import Swal from 'sweetalert2';
//import Swal from 'sweetalert2/dist/sweetalert2.js'
//import 'sweetalert2/src/sweetalert2.scss'
import { translate } from '../../Services/translation';
export const pnConfirm = (
    title,
    message,
    yesText = false,
    noText = false,
    icon = 'warning',
    showDenyButton = true,
    onClickYes = () => { },
    onClickNo = () => { },
) => (dispatch) => {
    Swal.fire({
        title,
        text: message,
        icon,
        allowOutsideClick: false,
        buttonsStyling: false,
        customClass: {
            confirmButton:
                'button button-green pn-confirm__button pn-confirm__button--confirm',
            denyButton:
                'button button-orange pn-confirm__button pn-confirm__button--cancel',
        },
        reverseButtons: false,
        showDenyButton,
        showCancelButton: false,
        confirmButtonText: yesText ? yesText : translate('common.genericerror.button.ok'),
        denyButtonText: noText ? noText : translate('common.genericerror.button.cancel'),
    }).then((result) => {
        if (result.isConfirmed) {
            onClickYes();
        } else if (result.isDenied) {
            onClickNo();
        }
    });
};
